require('./brokerStockInformativeButton.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @components
const OKModal = require('components/commons/OKModal/OKModal');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @commons
const { OKLink } = require('commonsComponents/OKLink');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @constants
const { TYPE_STOCKS } = require('constants/index');
const paragraphEStexts = [
    'brokerStockInformativeModal-brokerStockInformativeModal_EScontentText1',
    'brokerStockInformativeModal-brokerStockInformativeModal_EScontentText2',
    'brokerStockInformativeModal-brokerStockInformativeModal_EScontentText3'
];
const paragraphUStexts = [
    'brokerStockInformativeModal-brokerStockInformativeModal_UScontentText1',
    'brokerStockInformativeModal-brokerStockInformativeModal_UScontentText2',
    'brokerStockInformativeModal-brokerStockInformativeModal_UScontentText3'
];
//Copy the same POE string from above list to have a given link in expected paragraph
const textHasLink = 'brokerStockInformativeModal-brokerStockInformativeModal_UScontentText1';

class BrokerStockInformativeButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false
        }

        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.handleToggleModal = this.handleToggleModal.bind(this);
    }

    handleToggleModal() {
        const { isModalOpen } = this.state;
        this.setState({ isModalOpen: !isModalOpen });
    }

    handleButtonClick() {
        const { productType, crfRequired, w8Required } = this.props;

        if ((crfRequired || w8Required) && productType === TYPE_STOCKS) {
            this.handleToggleModal();
        } else {
            this.handleContinueClick();
        }
    }

    createModalContent(crfRequired, w8Required) {
        let content = [];
        if (crfRequired) {
            content = paragraphEStexts;
        } else if (w8Required) {
            content = paragraphUStexts;
        }

        return content.map((text, index) => {
            const linkElement = text === textHasLink && (
                <OKLink
                    modifier="emphasize"
                    extraClass="broker-my-investments-contracts__configuration-link"
                    to={formatText('brokerStockInformativeModal-brokerStockInformativeModal_UScontentLinkURL')}
                >
                    <FormattedText value="brokerStockInformativeModal-brokerStockInformativeModal_UScontentLinkText" />
                </OKLink>
            );

            return (
                <FormattedTextWithComponents
                    className="broker-stock-informative-button__paragraph"
                    injectedComponents={[linkElement]}
                    key={index}
                    value={text}
                />
            )
        });
    }

    createModal() {
        const { crfRequired, w8Required } = this.props;
        const modalContent = this.createModalContent(crfRequired, w8Required);

        return (
            <OKModal
                content={modalContent}
                footerType="navigation"
                isOpen={this.state.isModalOpen}
                onCloseCallback={this.handleToggleModal}
                onPrimaryButtonClick={this.handleContinueClick}
                onSecondaryButtonClick={this.handleToggleModal}
                primaryButtonText="brokerStockInformativeModal-brokerStockInformativeModal_primaryButtonText"
                secondaryButtonText="brokerStockInformativeModal-brokerStockInformativeModal_secondaryButtonText"
                title="brokerStockInformativeModal-brokerStockInformativeModal_title"
            />
        );
    }

    render() {
        const { children } = this.props;
        const childrenWithProps = React.Children.map(children, child => {
            this.handleContinueClick = child.props.onClick;
            return React.cloneElement(child, { onClick: this.handleButtonClick })
        });
        const modal = this.createModal();

        return (
            <React.Fragment>
                {modal}
                {childrenWithProps}
            </React.Fragment>
        );
    }
}

BrokerStockInformativeButton.propTypes = {
    children: PropTypes.object,
    productType: PropTypes.string,
    crfRequired: PropTypes.boolean,
    w8Required: PropTypes.boolean,
};

BrokerStockInformativeButton.defaultProps = {
    productType: '',
    crfRequired: false,
    w8Required: false,
};

module.exports.BrokerStockInformativeButton = BrokerStockInformativeButton;

